const validatePassword = (password, options = {}) => {
    const { // 기본 설정
        minLength = 4,
        maxLength = 20
    } = options;

    const passwordLength = password.length;
  
    // 1. 글자수 체크
    if (passwordLength < minLength || passwordLength > maxLength) {
        return {
            isValid: false
        };
    }
  
    // 2. 한글 체크
    if (/[가-힣\s]/.test(password)) {
        return {
            isValid: false
        };
    }

    // 3. 특수문자 체크
    if (/[\\/'\"<>|$`]/.test(password)) {
        return {
            isValid: false
        };
    }

    return { // 모든 검증 통과
        isValid: true
    };
};

export default validatePassword;
